// src/api/useSignUp.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";

const fetchRegisterStudents = (formData) => {
  return api.post("/study-users", formData);
};

/**
 * 회원가입 요청을 위한 useMutation 훅을 사용하는 커스텀 훅
 */
export const useRegisterStudentsQuery = () => {
  return useMutation({
    mutationFn: fetchRegisterStudents,
  });
};
